import PropTypes from "prop-types";

import { Button } from "@transfr-inc/dashboard-components/forms";

import { Card, CardBody, CardFooter, CardHeader, Modal } from "@features/ui";

import { buttonTracking } from "@lib/tracking.helpers";
import "./career-matches-start-over-confirmation.modal.scss";

export const CareerMatchesStartOverConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  onCancel,
  careerTitle,
}) => {
  const toolbar = (
    <Button
      icon={["fa-regular", "xmark"]}
      onClick={onClose}
      {...buttonTracking(
        "career-matches-start-over-confirmation-modal",
        "close",
      )}
    />
  );

  const message = careerTitle ? (
    <span>
      Would you like to start Trek from the beginning? We will remove your
      previous pathway and goals for <strong>{careerTitle}</strong>. This
      can&apos;t be undone.
    </span>
  ) : (
    <span>
      Would you like to start Trek from the beginning? We will remove your
      current survey responses and career matches. This can&apos;t be undone.
    </span>
  );

  return (
    <Modal
      key="career-matches-start-over"
      modalClassName="career-matches-start-over-confirmation-modal"
      open={open}
    >
      <Card>
        <CardHeader title={<h1>Start Over?</h1>} toolbar={toolbar} />
        <CardBody>{message}</CardBody>
        <CardFooter>
          <Button
            destructive
            onClick={onConfirm}
            {...buttonTracking(
              "career-matches-start-over-confirmation-modal",
              "yes",
            )}
          >
            Yes, start over
          </Button>
          <Button
            onClick={onCancel}
            {...buttonTracking(
              "career-matches-start-over-confirmation-modal",
              "no",
            )}
          >
            No, cancel
          </Button>
        </CardFooter>
      </Card>
    </Modal>
  );
};

CareerMatchesStartOverConfirmationModal.displayName =
  "Career Matches Start Over Confirmation Modal";

CareerMatchesStartOverConfirmationModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  careerTitle: PropTypes.string,
};
